<div class="position-relative overflow-hidden h-100 d-flex">
    <div class="flex-grow-1 overflow-hidden px-sm-4 pt-4">
        <dx-scheduler
            id="scheduler"
            [style]="(`height: calc(100vh - ${offset}px)`)"
            [dataSource]="events$ | async"
            [(currentDate)]="currentDate"
            [views]="['day', 'week', 'month']"
            [currentView]="'day'"
            [cellDuration]="15"
            (onOptionChanged)="onOptionChanged($event)"
            [startDayHour]="4"
            [endDayHour]="24"
            [maxAppointmentsPerCell]="4"
            appointmentTemplate="appointment-template"
            appointmentTooltipTemplate="tooltip-template"
            [editing]="false"
            [useDropDownViewSwitcher]="true"
            (onAppointmentDblClick)="onAppointmentDblClick($event)"
            [focusStateEnabled]="false"
            [adaptivityEnabled]="false"
            width="100%"
            (onAppointmentFormOpening)="$event.cancel = true"
        >
            <dxo-toolbar>
                <dxi-item class="d-none d-md-block" location="before">
                    <div class="scheduler-header">Calendar</div>
                </dxi-item>
                <dxi-item location="after" name="viewSwitcher"></dxi-item>
                <dxi-item location="after" name="dateNavigator"></dxi-item>
                <dxi-item location="after" locateInMenu="never" template="statusFilterTemplate"></dxi-item>
                <dxi-item location="after" locateInMenu="auto" widget="dxButton" showText="inMenu"
                    [options]="{ text: 'Clear Filters', icon: 'fa-sharp fa-thin fa-filter-slash', onClick: clearFilters, stylingMode: 'text' }"></dxi-item>
            </dxo-toolbar>

            <dxi-resource
                fieldExpr="displayStatus"
                label="Status"
                [dataSource]="statusResources[0].dataSource"
                [useColorAsDefault]="true"
            ></dxi-resource>

            <div *dxTemplate="let data of 'statusFilterTemplate'">
                <dx-tag-box [dataSource]="allStatuses" displayExpr="text" valueExpr="value"
                    [value]="filterModel.selectedStatuses" [showSelectionControls]="true"
                    [applyValueMode]="'useButtons'" [multiline]="false" [maxDisplayedTags]="1" [width]="220"
                    [placeholder]="'Status'" (onValueChanged)="onStatusFilterChanged($event)"></dx-tag-box>
            </div>

            <div *dxTemplate="let model of 'appointment-template'">
                <div class="h-100 d-flex justify-content-between overflow-hidden"
                    [ngClass]="getAppointmentTextClass(getEventData(model.appointmentData))">
                    <div class="fw-medium text-truncate"> {{ getEventData(model.appointmentData).label }} </div>
                    <div>{{ getEventData(model.appointmentData).status | appointmentStatus }}</div>
                </div>
            </div>
            <div *dxTemplate="let model of 'tooltip-template'" class="custom-tooltip">
                <div class="dx-tooltip-appointment-item" (click)="onTooltipClick(model.appointmentData.number)">
                    <div class="dx-tooltip-appointment-item-marker">
                        <div class="dx-tooltip-appointment-item-marker-body"
                            [ngClass]="getAppointmentMarkerClass(getEventData(model.appointmentData))">
                        </div>
                    </div>
                    <div class="dx-tooltip-appointment-item-content m-0">
                        <div class="dx-tooltip-appointment-item-content">
                            <div class="dx-tooltip-appointment-item-content-subject d-flex justify-content-between">
                                <div class="me-1">
                                    {{ getEventData(model.appointmentData).label }}
                                </div>
                                <div class="small text-truncate">
                                    <span class="badge" [ngClass]="getBadgeClass(getEventData(model.appointmentData).status)">
                                        {{ getEventData(model.appointmentData).status | appointmentStatus }}
                                    </span>
                                </div>
                            </div>
                            <div class="dx-tooltip-appointment-item-content-date d-flex justify-content-between">
                                <div class="small">
                                    {{ model.appointmentData.startDate | date:'h:mm a' }} - {{ model.appointmentData.endDate | date:'h:mm a' }}
                                </div>
                                <div class="small">
                                    {{ model.appointmentData.number }} - {{ model.appointmentData.loadType | capitalCase }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </dx-scheduler>
    </div>
</div>
